import {
  AsynchronousActivityRequest,
  AttendanceRequest,
  AttendanceScheduleRequest,
  BulkAttendanceRequest,
  LoadingAttendanceState,
  ReassignLeaderRequest,
  ReassignWeekAbsentRequest,
} from '@tsin-core/models/attendance.model';

export class UpdateAttendance {
  static readonly type = '[Attendance] Update';
  constructor(public payload: AttendanceRequest) { }
}

export class UpdateAsynchronousActivity {
  static readonly type = '[Attendance] Update Asynchronous';
  constructor(public payload: AsynchronousActivityRequest) { }
}

export class GetAttendanceByScheduleSession {
  static readonly type = '[Attendance] Get Attendance By Schedule and Session';
  constructor(public payload: AttendanceScheduleRequest) { }
}

export class GetAttendanceByWeeklySchedule {
  static readonly type = '[Attendance] Get Attendance By Weekly Schedule';
  constructor(public payload: string) { }
}

export class GetAsynchronousActivitySchedule {
  static readonly type = '[Attendance] Get Asynchronous Activity By Weekly Schedule';
  constructor(public payload: string) { }
}

export class GetAsyncActivitiesByWeekly {
  static readonly type = '[Attendance] Get Async Activities By Weekly';
  constructor(public payload: string) { }
}

export class GetAsyncActivitiesByYear {
  static readonly type = '[Attendance] Get Async Activities By Year';
  constructor(public payload: number) { }
}

export class SetLoading {
  static readonly type = '[Attendance] Set Loading';
  constructor(public loading: LoadingAttendanceState) { }
}

export class SetError {
  static readonly type = '[Attendance] Set Error';
  constructor(public error: string | null) { }
}

// ─── Leader Replacement Actions ───────────────────────────────────────────────

/**
 * Fetch scored replacement candidates for a session-user's leadership slots.
 * Récupérer les candidats classés pour les créneaux de leadership d'un utilisateur de session.
 */
export class GetLeaderSuggestion {
  static readonly type = '[Attendance] Get Leader Suggestion';
  constructor(public sessionUserId: string) {}
}

/**
 * Manually reassign a single leadership slot to a new learner.
 * Réassigner manuellement un créneau de leadership à un nouvel apprenant.
 */
export class ReassignLeaderManual {
  static readonly type = '[Attendance] Reassign Leader Manual';
  constructor(public payload: ReassignLeaderRequest) {}
}

/**
 * Auto-reassign all leadership slots for a week-absent learner.
 * Réassigner automatiquement tous les créneaux d'un apprenant absent pour la semaine.
 */
export class ReassignWeekAbsent {
  static readonly type = '[Attendance] Reassign Week Absent';
  constructor(public payload: ReassignWeekAbsentRequest) {}
}

/** Clear the cached leader suggestions (e.g. when dialog is closed). */
export class ClearLeaderSuggestions {
  static readonly type = '[Attendance] Clear Leader Suggestions';
}

/**
 * Submit attendance for multiple learners in a single request.
 * Soumettre la présence pour plusieurs apprenants en une seule requête.
 */
export class BulkAttendance {
  static readonly type = '[Attendance] Bulk Attendance';
  constructor(public payload: BulkAttendanceRequest) {}
}
